/* eslint-disable no-nested-ternary */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useState, useEffect, useMemo, useRef } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Button from "../../shared/button";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import Tooltip from "../../shared/tooltip";
import { getTooltipInfoList, getPersonalisedTooltipInfoList } from "../../../utils/helpers/car-properties";
import InfoOutline from "./images/info-outline.svg";
import WhiteTickIcon from "./../../shared/images/white-tick.svg";
import { useHistory } from "react-router-dom";
import IconHeart from "../../shared/icon-heart/component";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";

import loadable from "@loadable/component";
import { AB_TEST_VARIATIONS, CAR_LIST_EVENT_NAMES, INVENTORY_CAR_CARD_LABELS, NUMBER, ORDER_TYPE, PAGE_SOURCE, FILTER_KEYS, API_SOURCE } from "../../../constants/app-constants";
const SellerTypeInfo = loadable(() => import("../seller-type-info/component"));
import ThreeDayDeliveryPopup from "../three-day-delivery-popup/component";
import InfoIcon from "./images/info-icon.svg";

const EGCPriceView = loadable(() => import("../egc-price-view"));
import {
    checkActiveExperimentVariants,
    getAbExpirementVariant,
    showNewTestDriveVariant,
    showTestDriveVariant
} from "../../../utils/helpers/get-ab-expirement-variant";
import HowToBookTestModal from "../how-to-book-test-modal";
import TestDriveFaqModal from "../test-drive-faq-modal/component";
import { getTestDriveCheckoutURL, getTestDriveV2CheckoutURL } from "../../../utils/helpers/get-detail-page-url";
import { LOGIN_TYPE, ORDER_STATUS } from "../../../constants/checkout-constants";
const KbbPriceScreen = loadable(() => import("../../shared/kbb-price-screen/component"));
import { modelYearNameGenerator } from "../../../utils/helpers/model-year-name-generator";
import { TEST_DRIVE_V2_ROUTE_PATHS } from "../../../constants/au.desktop/checkout-route-paths";
import { getTestDriveCtaText } from "../../../utils/helpers/get-test-drive-cta-text";
import TrackImpression from "../../shared/track-impression";
import { CDP_REVAMP_AMPLITUDE_EVENTS } from "../../../tracking/amplitude-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { EVENT_DATA, EVENT_NAME } from "./tracking";
import useUserGeoLocation from "../../../hooks/use-user-geo-location";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
// import LocationIcon from "./images/location.svg";
// import backArrow from "./images/arrow-back.svg";
const HubLocationModal = loadable(() => import("../hub-loaction-modal"));
import useCarHighlightLocation from "../../../hooks/use-car-highlight-location";
import CarDetailsInfo from "./car-details-info";
import CdpPriceDetailCard from "../cdp-price-detail-card";
import getCarInfo from "../../../utils/helpers/get-car-info";
// import CdpDetailsVariantC from "../cdp-value-deal-detail-card";
import { useEwVariantConfig } from "../../../hooks/use-ew-variant-config";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import WarrantyModal from "../post-payment-journey/add-ons-plans/warranty-modal/component";
import LinkButton from "./images/link-button.svg";
import InfoIconWhite from "./images/info_outline_white.svg";
import { VIDEO_CATALOG_AMPLITUDE_EVENTS, VIDEO_CATALOG_GA_EVENTS_DESKTOP } from "../video-gallery-slider/tracking";
import { getStripConfiguration } from "./constants";
import CdpEwSelectionCard from "../cdp-ew-selection-card";
import useVehicleBasePriceLabel from "../../../hooks/use-vehicle-base-price-label";
import useLoginGate from "../../../hooks/use-login-gate";

const CarDetailsCardRevamp = ({
    content,
    isWishlisted,
    onWishlistClick,
    ctaProps = {},
    imageHost,
    deliveryInfo,
    source,
    order,
    setLoginTypeConnect,
    tradeInToggleSelected,
    createOrderConnect,
    isUserZeroDpVariant,
    isFetchingOrderDetails,
    personalDetails,
    updateProfileConnect,
    secureToken,
    orderId,
    calculatorRef,
    scrollToSection,
    updateValidC2bOrderConnect,
    webPriceDropDesktop,
    testDriveConfig,
    cmsConfig,
    desktopCdpEw,
    paymentSummaryData,
    updateExtendedWarrantySelectionConnect,
    isVideoGalleryModalOpen,
    viewDetailsClick,
    isCdpCtaReorderVariant,
    getValidQuotesInHouseFinanceConnect,
    updateBasicHubspotConnect,
    getOrderDetailSuccessConnect,
    setTestDriveVariantConnect,
    getInhouseEligibilityConnect,
    getInhousePreApprovalLoanDetailsConnect,
    userEmail,
    userTradeInData,
    globalCmsConfig,
    preApprovalOnFlyDesktop,
    startPreApprovalOnFlyConnect,
    comingSoonExperiment
}) => {
    const { shippingPrice = 0, pickupCharges } = deliveryInfo || {};
    const history = useHistory();
    const {
        make,
        model,
        modelYear,
        year,
        bodyType,
        price,
        egc = 0,
        personalised,
        kbbAskingPrice,
        vehicleRetailPrice,
        serviceHistory = [],
        kbbValueProvidedOn,
        isPriceDrop,
        promotion,
        cityCode = "",
        reserved
    } = content || {};

    const {
        egcPriceLabel,
        emiPerWeek,
        emiDetails,
        estimatedPrice,
        initialListingPrice,
        carLabel,
        appointmentId,
        variant,
        transmissionType,
        odometer: odometerReading,
        ewDetails,
        kilometerLabel,
        isInternalListing,
        isDealerListing,
        isLuxuryCar,
        priceMeta,
        defaultDiscount,
        defaultSale,
        comingSoon
    } = getCarInfo(content) || {};
    const vehicleAskingPrice = vehicleRetailPrice || kbbAskingPrice ||  0;
    const { deliveryMode, testDriveStatus = "" } = order || {};
    const userGeoData = useUserGeoLocation();
    const { state: { name: userState = {} } = {}, country: { isoCode: countryCode } = {} } = userGeoData || {};
    const isTestDriveVariant = showTestDriveVariant({ content, order });
    const { eligibleStateNames = [], enabledForIndia: isTestDriveEnabledForIndia = false } =
        testDriveConfig?.data || {};
    const isNewTestDriveLocationVariant = showNewTestDriveVariant({
        content,
        order,
        userState,
        countryCode,
        isTestDriveEnabledForIndia,
        eligibleStateNames,
        comingSoonExperiment
    });
    const testDriveDisabled = ctaProps?.key === "comingSoon" ? false : ctaProps?.disabled;
    const { tradeIn = false, tradeInAmount: tradeInPrice } = userTradeInData || {};
    const [showExtendedWarrantyEGC, setShowExtendedWarrantyEGC] = useState(false);
    const [isWhatIsCoveredModalOpen, setIsWhatIsCoveredModalOpen] = useState(false);
    const { defaultDownPayment } = emiDetails || {};
    const modelYearName = modelYearNameGenerator(modelYear);
    const [showHubLocationModal, setShowHubLocationModal] = useState(false);

    const { currentCarCityInfo = {} } = useCarHighlightLocation(cityCode);
    const cityHub = currentCarCityInfo || {};

    const hubCityName = cityHub?.cityName || "Unknown location";
    const carName = `${year} ${make} ${model} ${modelYearName}`;
    const kbbMarketPrice = vehicleAskingPrice - egc;
    const showKbbMarketPrice = egc < vehicleAskingPrice && kbbMarketPrice >= NUMBER.FIVE_HUNDRED && kbbMarketPrice < NUMBER.TEN_THOUSAND;
    const onSale = promotion === "On sale";

    const [showEcgPrice, setShowEcgPrice] = useState(false);
    const [showExpressDeliveryPopup, setShowExpressDeliveryPopup] = useState(false);
    const [showKBBModal, setShowKBBModal] = useState(false);
    const [showTestDriveLocationInfo, setShowTestDriveLocationInfo] = useState(false);
    const [showSellerTypeInfo, setShowSellerTypeInfo] = useState({ view: false, key: FILTER_KEYS.CARS24 });

    const [showTestDriveModal, setShowTestDriveModal] = useState(false);
    const [showFaqModal, setShowFaqModal] = useState(false);
    const tooltipRef = React.useRef(null);
    const proceedWithTestDriveRef = useRef(null);
    const testDriveGate = useLoginGate({
        requiredFields: ["profileName", "email", "mobile"],
        persistKey: "logingate_test_drive",
        onComplete: () => proceedWithTestDriveRef.current()
    });
    const [eventCategory, setEventCategory] = useState({});
    const showWebPriceDesktop = getAbExpirementVariant(webPriceDropDesktop, EXPERIMENT_TYPE.VARIANT_B);
    const { vehiclePriceLabel, isVehicleBasePriceVariant } = useVehicleBasePriceLabel({
        source: API_SOURCE.DESKTOP,
        isInternalListing,
        isDealerListing
    });

    const { showEwVariantA, showEwVariantB, showEwVariantC, showEwVariantF } = useEwVariantConfig(desktopCdpEw, paymentSummaryData, ewDetails, source);
    const variantBStyles = !(showEwVariantA || showEwVariantC);
    const showStrikeThru = carLabel === INVENTORY_CAR_CARD_LABELS.PRICE_DROP || defaultSale || isPriceDrop;
    useEffect(() => {
        const isExtendedWarrantyPreSelectedVariant = checkActiveExperimentVariants(desktopCdpEw, [EXPERIMENT_TYPE.VARIANT_E, EXPERIMENT_TYPE.VARIANT_D]) && !showEwVariantA;
        if (isExtendedWarrantyPreSelectedVariant && typeof ewDetails !== "undefined") {
            updateExtendedWarrantySelectionConnect(true);
        } else {
            updateExtendedWarrantySelectionConnect(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Object.keys(ewDetails || {})?.length]);

    const handleModal = () => {
        setShowTestDriveModal(!showTestDriveModal);
    };

    const handleFaqModal = () => {
        setShowFaqModal(!showFaqModal);
    };

    const handleGetPreApprovalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isPreApprovalOnFlyVariant = getAbExpirementVariant(
            preApprovalOnFlyDesktop,
            EXPERIMENT_TYPE.VARIANT_B
        );
        if (isPreApprovalOnFlyVariant && startPreApprovalOnFlyConnect) {
            startPreApprovalOnFlyConnect({ entryPoint: "cdp-price-card", ctaText: "Continue Booking", refetchOnClose: true });
        } else {
            history.push("/financing/get-pre-approval");
        }
    };

    const BottomLink = () => {
        return (
            <div styleName={"styles.bottomLink"}>
                <span>Want to know your exact finance rates?</span>
                <Button
                    text="GET PRE-APPROVAL"
                    leftImage={WhiteTickIcon}
                    onClick={handleGetPreApprovalClick}
                    btnView="new"
                />
                <small>No impact on your credit score</small>
            </div>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setShowTestDriveLocationInfo(false);
            } else if (tooltipRef.current?.contains(event.target)) {
                if (showTestDriveLocationInfo) {
                    setShowTestDriveLocationInfo(false);
                } else {
                    setShowTestDriveLocationInfo(true);
                }
            }
        };
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, [showTestDriveLocationInfo]);

    const tooltipInfo = useMemo(() => {
        const getInfo = (emiPerWeekValue, emiDetailsValue) => ({
            title: `Weekly payment of ${makePriceLabelRound(emiPerWeekValue)}`,
            body: personalised
                ? getPersonalisedTooltipInfoList(emiDetailsValue)
                : getTooltipInfoList(emiDetailsValue, isUserZeroDpVariant).concat(<BottomLink />)
        });
        const info = getInfo(emiPerWeek, emiDetails);

        let ewInfo = null;
        if (ewDetails && Object.keys(ewDetails).length > 0) {
            const { emiDetails: ewEmiDetails = {} } = ewDetails;
            ewInfo = getInfo(ewEmiDetails?.emiPerWeek, ewEmiDetails);
        }

        return { info, ...(ewInfo && { ewInfo }) };
    }, [emiPerWeek, personalised, emiDetails, ewDetails, isUserZeroDpVariant]);

    const handleEgcView = (val = false) => {
        setShowEcgPrice(!showEcgPrice);
        setShowExtendedWarrantyEGC(val);
    };

    const handleShowPop = () => {
        setShowExpressDeliveryPopup(!showExpressDeliveryPopup);
    };

    const onClickTestDrive = async () => {
        const { relativeURL } = getTestDriveCheckoutURL(content, "finance");
        history.push(relativeURL);
        setLoginTypeConnect(LOGIN_TYPE.TEST_DRIVE);
        if (source === PAGE_SOURCE.VIDEO_GALLERY) {
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CHECKOUT_INITIATED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CHECKOUT_INITIATED,
                eventLabel: "Yes"
            });
        }
    };

    const displayIcon = () => {
        if (!ctaProps.iconType) {
            return null;
        } else if (ctaProps.iconType === "Info") {
            return (
                <div styleName={"styles.hovertext"}>
                    <div styleName={"styles.infoicon"}>
                        <img src={InfoIcon} alt={InfoIcon} />
                    </div>
                    <div styleName={"styles.paraContent styles.top_arrow"}>
                        <p>
                            You can choose to be notified if this car becomes available to purchase in the near future
                        </p>
                    </div>
                </div>
            );
        } else {
            return source !== PAGE_SOURCE.VIDEO_GALLERY ? (
                <div styleName={"styles.wishlistBtn"}>
                    <IconHeart active={isWishlisted} onClick={onWishlistClick} source="cdp_revamp_gradient" />
                </div>
            ) : null;
        }
    };

    const handleOpenMarketModal = () => {
        setShowKBBModal(!showKBBModal);
    };

    const getProfilePayload = () => {
        const { firstName, lastName } = personalDetails || {};
        return {
            ...personalDetails,
            firstName: firstName ? firstName.trim() : "",
            lastName: lastName ? lastName.trim() : ""
        };
    };
    const updateProfile = async (payload) => {
        try {
            await updateProfileConnect(payload, secureToken);
        } catch (error) {
            throw error;
        }
    };

    // Ref keeps onComplete callback fresh across renders (used by useLoginGate after SSO reload)
    const proceedWithTestDrive = async () => {
        let redirectUrl = "";
        if (testDriveStatus === ORDER_STATUS.BOOKED) {
            const { relativeURL: bookingConfirmationRoute } = getTestDriveV2CheckoutURL(content, TEST_DRIVE_V2_ROUTE_PATHS.bookingConfirmed);
            redirectUrl = bookingConfirmationRoute;
        } else {
            //* Should be fired before "purchase started" event inside createOrderConnect(orderPayload) below
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_V2_CTA_SELECTED, {
                eventLabel: "test_drive",
                eventAction: "cta_selected"
            });
            trackDesktopCustomEventsAU(EVENT_NAME.CHECKOUT_INITIATED, EVENT_DATA.CHECKOUT_INITIATED);
            const orderPayload = {
                vehiclePrice: getCarPrice({ egcPrice: content.egc, dapPrice: content.price }).egc.value,
                appointmentId,
                orderType: ORDER_TYPE.PRODUCT_TEST_DRIVE,
                tdUserType: AB_TEST_VARIATIONS.TEST,
                deliveryAddress: { customerPhoneNumber: personalDetails.phone },
                pickUpAddress: { customerPhoneNumber: personalDetails.phone },
                source: "WebApp"
            };
            const profilePayload = getProfilePayload();
            try {
                let orderResponse;
                if (orderId) {
                    await updateProfile(profilePayload);
                } else {
                    orderResponse = await createOrderConnect(orderPayload);
                    getOrderDetailSuccessConnect(orderResponse);
                }
                await Promise.allSettled([
                    getValidQuotesInHouseFinanceConnect(CAR_LIST_EVENT_NAMES.TEST_DRIVE_FINANCE),
                    getInhousePreApprovalLoanDetailsConnect()
                ]);
                await getInhouseEligibilityConnect();
                if (!orderId) {
                    await updateProfile(profilePayload);
                    updateBasicHubspotConnect(orderResponse?.orderId, { ...orderResponse, source: "WebApp" });
                    setTestDriveVariantConnect({ email: userEmail || personalDetails.userEmail, testDriveVariant: true });
                }
            } catch (error) {
                // proceed to finance even if some calls fail
            }
            const { relativeURL: financeRoute } = getTestDriveV2CheckoutURL(
                content,
                TEST_DRIVE_V2_ROUTE_PATHS.finance
            );
            redirectUrl = financeRoute;
            updateValidC2bOrderConnect(secureToken);
        }
        if (EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(EVENT_DATA.CTA_OPTIMIZATION);
        }
        if (source === PAGE_SOURCE.VIDEO_GALLERY) {
            trackDesktopCustomEventsAU(VIDEO_CATALOG_AMPLITUDE_EVENTS.VIDEO_CHECKOUT_INITIATED, {
                ...VIDEO_CATALOG_GA_EVENTS_DESKTOP.VIDEO_CHECKOUT_INITIATED,
                eventLabel: "Yes"
            });
        }
        history.push(redirectUrl);
    };

    proceedWithTestDriveRef.current = proceedWithTestDrive;

    const onClickTestDriveV2 = () => {
        testDriveGate.trigger();
    };

    const onClickFinanceInfo = () => {
    };

    useEffect(() => {
        if (isNewTestDriveLocationVariant) {
            setEventCategory(AU_DESKTOP_EVENTS.BUY_ONLINE_CTA_CLICKED);
        } else if (source === "gallery") {
            setEventCategory(AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW);
        } else {
            setEventCategory(AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS);
        }
    }, [isNewTestDriveLocationVariant, source]);

    const handleHubLocationArrowClick = () => {
        setShowHubLocationModal(true);
    };

    const handleOnHubLocationModalClose = () => {
        setShowHubLocationModal(false);
    };

    const handleSellerTypeInfoClick = () => {
        const tagName = isLuxuryCar ? FILTER_KEYS.CARS24_LUXE : isInternalListing ? FILTER_KEYS.CARS24 : FILTER_KEYS.CLASSIFIEDS;
        setShowSellerTypeInfo({ view: true, key: tagName });
    };

    const handleLoanCalculatorClick = () => {
        scrollToSection(calculatorRef);
    };

    const handleWarrantyModalClick = async () => {
        setIsWhatIsCoveredModalOpen(true);
        await yieldToMain();

        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.STATE_WISE_PRICING_STATE_SELECT, {
            eventLabel: "NA"
        });

    };

    const renderCarDetails = () => {
        const carDetailCardProps = {
            showKbbMarketPrice,
            strikeThroughtPrice: initialListingPrice,
            carPrice: tradeInToggleSelected ? estimatedPrice : egcPriceLabel,
            emiPerWeek,
            onLoanCalculatorClick: handleLoanCalculatorClick,
            handleEgcView,
            tradeInCase: tradeInToggleSelected,
            emiDetails,
            handleWeeklyPaymentsTooltipClick: onClickFinanceInfo,
            personalised,
            ewDetails,
            // showWarrantyModal: updateWarrantyModal,
            showStrikeThru,
            tooltipInfo,
            isPriceDrop,
            handleWarrantyModalClick,
            appointmentId
        };
        if (showEwVariantA) {
            return <CarDetailsVariantA />;
        } else if (ewDetails) {
            return (
                <React.Fragment>
                    {showEwVariantB && <CdpPriceDetailCard {...carDetailCardProps} />}
                    {showEwVariantF && <CdpEwSelectionCard {...carDetailCardProps} />}
                </React.Fragment>
            );
        } else return null;
    };

    const salePriceStrikeStyle = isVideoGalleryModalOpen ? "styles.videoGallerySalePriceStrike" : "styles.salePriceStrike";
    const priceContainerStyle = isVideoGalleryModalOpen ? "styles.videoGalleryPriceContainer" : "styles.priceContainer";
    const dapLabelStyle = isVideoGalleryModalOpen ? "styles.videoGalleryDapLabel" : "styles.dapLabel";
    const financingLabelStyle = isVideoGalleryModalOpen ? "styles.videoGalleryFinancingLabel" : "styles.financingLabel";
    const zeroDPWeeklyStyle = isVideoGalleryModalOpen ? "styles.videoGalleryZeroDPWeekly" : "styles.zeroDPWeekly";
    const priceBreakUpStyle = isVideoGalleryModalOpen ? "styles.videoGalleryPriceBreakUp" : "styles.priceBreakUp";

    const CarDetailsVariantA = () => (
        <div styleName={`${onSale ? "styles.salePriceWrap" : ""}`}>
            {!isVehicleBasePriceVariant && (
                <p
                    styleName={`${dapLabelStyle} ${!isDealerListing ? (isVideoGalleryModalOpen ? "styles.videoGalleryClickableDapLabel" : "styles.clickableDapLabel") : ""}`}
                    onClick={!isDealerListing ? () => handleEgcView(true) : undefined}
                >
                    {vehiclePriceLabel}
                </p>
            )}

            <div styleName={"styles.leftTopSection"}>
                <div styleName={"styles.leftTopInnerSection"}>
                    <div styleName={"styles.priceLabelWrap"}>
                        <p styleName={priceContainerStyle}>
                            {tradeInToggleSelected
                                ? estimatedPrice
                                : getCarPrice({
                                    egcPrice: egc,
                                    dapPrice: price,
                                    shippingPrice,
                                    pickupCharges,
                                    deliveryMode
                                }).egc.label}
                            {onSale && <span styleName={salePriceStrikeStyle}>{makePriceLabelRound(price)}</span>}
                            {((isPriceDrop && showWebPriceDesktop)) && (
                                <span styleName={salePriceStrikeStyle}>{makePriceLabelRound(initialListingPrice)}</span>
                            )}
                        </p>

                        {isVehicleBasePriceVariant && (
                            <p
                                styleName={`${dapLabelStyle} ${isVideoGalleryModalOpen ? "" : "styles.variantBDapLabel"}`}
                            >
                                {vehiclePriceLabel}
                            </p>
                        )}
                    </div>
                    {isInternalListing ? <p styleName={`${priceBreakUpStyle} ${isVehicleBasePriceVariant && !isVideoGalleryModalOpen ? "styles.priceBreakUpVariantB" : ""}`} onClick={() => handleEgcView()}>
                        {isVehicleBasePriceVariant ? "See drive away price" : "See price break down"}
                    </p> : ""}
                </div>
            </div>
            <p styleName={financingLabelStyle}>Financing</p>
            <div styleName={"styles.zeroDpInfo"}>
                <p styleName={zeroDPWeeklyStyle}>{makePriceLabelRound(emiPerWeek)}<span>/week</span>
                    <Tooltip
                        onClickCallback={onClickFinanceInfo}
                        customStyleHeading={true}
                        heading={tooltipInfo?.info?.title}
                        body={tooltipInfo?.info?.body}
                    >
                        <img styleName="styles.infoTooltipIcon" src={isVideoGalleryModalOpen ? InfoIconWhite : InfoOutline} alt="Weekly Payment" />
                    </Tooltip>
                </p>
                {/* <p styleName={bestInterestRateLabelStyle}>
                    <span>%</span> BEST INTEREST RATES
                </p> */}
                {defaultDownPayment === NUMBER.ZERO && <p styleName={"styles.zeroDeposit"}>$0 deposit</p>}
                {
                    source !== PAGE_SOURCE.VIDEO_GALLERY && (
                        <p styleName={`${priceBreakUpStyle} ${isVehicleBasePriceVariant && !isVideoGalleryModalOpen ? "styles.priceBreakUpVariantB" : ""}`} onClick={handleLoanCalculatorClick}>
                        Loan Calculator
                        </p>
                    )
                }
            </div>
        </div>
    );

    const updateWarrantyModal = async () => {
        setIsWhatIsCoveredModalOpen(!isWhatIsCoveredModalOpen);
        await yieldToMain();
        trackDesktopCustomEventsAU(EVENT_DATA.EW_POPUP_OPEN, {
            ...EVENT_DATA.EW_POPUP_OPEN,
            eventAction: "source",
            eventLabel: "cdp"
        });
    };

    const carCardStyle = isVideoGalleryModalOpen ? "styles.videoGalleryCarCard" : "styles.carCard";
    const carCardBottomContentWrapperStyle = isVideoGalleryModalOpen ? "styles.videoGalleryCarCardBottomContentWrapper" : "styles.carCardBottomContentWrapper";
    const buttonWrapStyle = `styles.buttonWrap ${isVideoGalleryModalOpen ? "styles.videoGalleryButtonWrap" : ""} ${isTestDriveVariant ? "styles.test-drive-paading" : ""} ${variantBStyles ? "styles.bottomWrapremoveTopPadding" : ""}`;
    const stripConfig = getStripConfiguration({
        reserved,
        comingSoon,
        isPriceDrop,
        priceDiff: makePriceLabelRound(priceMeta?.priceDiff),
        defaultSale,
        defaultDiscount,
        priceDropUpdatedAt: priceMeta?.updatedAt,
        showTradeInStrip: tradeIn && tradeInToggleSelected,
        tradeInPrice,
        isDealerListing
    });

    return (
        <React.Fragment>
            <div styleName={`${carCardStyle} ${variantBStyles ? "styles.ewVariantBouterContainer" : ""}`}>
                <CarDetailsInfo
                    carName={carName}
                    odometerReading={odometerReading}
                    bodyType={bodyType}
                    transmissionType={transmissionType}
                    variant={variant}
                    serviceHistory={serviceHistory}
                    showBelowMarket={showKbbMarketPrice && !showWebPriceDesktop && !showEwVariantA}
                    kbbMarketPrice={kbbMarketPrice}
                    isEwVariantB={!showEwVariantA && showEwVariantB}
                    handleParkedLocationClick={handleHubLocationArrowClick}
                    hubCityName={hubCityName}
                    onClose={handleOpenMarketModal}
                    egc={egc}
                    vehicleRetailPrice={vehicleRetailPrice}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                    handleOpenMarketModal={handleOpenMarketModal}
                    kilometerLabel={kilometerLabel}
                    isVideoGalleryModalOpen={isVideoGalleryModalOpen}
                    stripConfig={stripConfig}
                    isInternalListing={isInternalListing}
                    isLuxuryCar={isLuxuryCar}
                    onSellerTypeInfoClick={handleSellerTypeInfoClick}
                />
                <div
                    styleName={`${carCardBottomContentWrapperStyle} ${variantBStyles ? "styles.variantBCarCard" : ""}`}
                >
                    {renderCarDetails()}
                    <TrackImpression event={{ name: CDP_REVAMP_AMPLITUDE_EVENTS.GET_STARTED_CTA_VIEWED }}>
                        <div
                            styleName={buttonWrapStyle}
                        >
                            {displayIcon()}
                            {ctaProps.transparentButton ? (
                                <div styleName={`styles.transparentBtns`}>
                                    <Button
                                        transparent
                                        text={ctaProps.text}
                                        disabled={ctaProps.disabled}
                                        isLoading={ctaProps.isLoading}
                                        onClick={(e) => ctaProps.action(eventCategory, e)}
                                    />{" "}
                                </div>
                            ) : (
                                <div styleName={"styles.buttonContainer"}>
                                    {isCdpCtaReorderVariant ? (<>
                                        <div styleName={"styles.btnWidth"}>
                                            <Button
                                                variant={!isDealerListing ? "secondary" : "primary"}
                                                text={ctaProps.text}
                                                disabled={ctaProps.disabled}
                                                isLoading={ctaProps.isLoading}
                                                onClick={(e) => ctaProps.action(eventCategory, e)}
                                            />
                                        </div>
                                        {isNewTestDriveLocationVariant &&
                                        !isTestDriveVariant &&
                                        isTestDriveEnabledForIndia && (
                                            <React.Fragment>
                                                {!isFetchingOrderDetails ? (
                                                    <div styleName="styles.btnWidth">
                                                        <Button
                                                            text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                            disabled={testDriveDisabled}
                                                            onClick={onClickTestDriveV2}
                                                            isLoading={ctaProps.isLoading}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="shimmer" styleName={"styles.ctaShimmer"} />
                                                )}
                                            </React.Fragment>
                                        )}

                                    </>) : (<>
                                        {isNewTestDriveLocationVariant &&
                                        !isTestDriveVariant &&
                                        isTestDriveEnabledForIndia && (
                                            <React.Fragment>
                                                {!isFetchingOrderDetails ? (
                                                    <div styleName="styles.btnWidth">
                                                        <Button
                                                            variant={"secondary"}
                                                            text={getTestDriveCtaText(ORDER_STATUS[testDriveStatus])}
                                                            disabled={testDriveDisabled}
                                                            onClick={onClickTestDriveV2}
                                                            isLoading={ctaProps.isLoading}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="shimmer" styleName={"styles.ctaShimmer"} />
                                                )}
                                            </React.Fragment>
                                        )}
                                        <div styleName={"styles.btnWidth"}>
                                            <Button
                                                text={ctaProps.text}
                                                disabled={ctaProps.disabled}
                                                isLoading={ctaProps.isLoading}
                                                onClick={(e) => ctaProps.action(eventCategory, e)}
                                            />
                                        </div>

                                    </>)}

                                </div>
                            )}
                        </div>
                    </TrackImpression>
                    {
                        isVideoGalleryModalOpen ? (
                            <div onClick={viewDetailsClick} styleName={"styles.videoGalleryBottomWrapper"}>
                                <p styleName={"styles.videoGalleryBottomWrapperText"}>  </p>
                                <img src={LinkButton} alt="Back arrow image" />
                            </div>

                        ) : (
                            null
                        )
                    }

                    {/* <p styleName={"styles.returnPolicy"}>7 day return policy</p> */}
                </div >
            </div >

            {showEcgPrice &&
                <EGCPriceView
                    {...content}
                    onClose={handleEgcView}
                    config={{ imageHost }}
                    type=""
                    pricingSource={PAGE_SOURCE.CDP}
                    bodyType={content.body || content.bodyType}
                    cta={ctaProps}
                    showExtendedWarrantyEGC={showExtendedWarrantyEGC}
                />}

            {
                showExpressDeliveryPopup &&
                <ThreeDayDeliveryPopup handleShowPop={handleShowPop}
                    showExtendedWarrantyEGC={showExtendedWarrantyEGC}
                />
            }

            {showExpressDeliveryPopup && <ThreeDayDeliveryPopup handleShowPop={handleShowPop} />}
            {showTestDriveModal && (
                <HowToBookTestModal
                    handleFaqModal={handleFaqModal}
                    onClose={handleModal}
                    onClickTestDrive={onClickTestDrive}
                />
            )}
            {showFaqModal && <TestDriveFaqModal onClose={handleFaqModal} onClickTestDrive={onClickTestDrive} />}

            {showKBBModal && (
                <KbbPriceScreen
                    onClose={handleOpenMarketModal}
                    egc={egc}
                    vehicleRetailPrice={vehicleRetailPrice}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                />
            )}
            {showHubLocationModal && <HubLocationModal cityHubInfo={cityHub} onClose={handleOnHubLocationModalClose} />}
            {showSellerTypeInfo.view && (
                <SellerTypeInfo
                    globalCmsConfig={globalCmsConfig}
                    activeTab={showSellerTypeInfo.key}
                    onClose={() => setShowSellerTypeInfo({ view: false, key: FILTER_KEYS.CARS24 })}
                />
            )}
            <div />
            {<WarrantyModal
                onClose={updateWarrantyModal}
                isOpen={isWhatIsCoveredModalOpen}
                planKey={"EXTENDED_WARRANTY_PLAN"}
                modalHeading={"Cars24 Extended Warranty"}
                cmsConfig={cmsConfig?.data || cmsConfig}
            />}
        </React.Fragment>
    );
};

CarDetailsCardRevamp.propTypes = {
    content: PropTypes.object,
    ctaProps: PropTypes.object,
    history: PropTypes.object,
    order: PropTypes.string,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    comingSoon: PropTypes.bool,
    personalised: PropTypes.bool,
    handleKbbModal: PropTypes.func,
    imageHost: PropTypes.string,
    source: PropTypes.string,
    deliveryInfo: PropTypes.object,
    onSale: PropTypes.bool,
    saleConfig: PropTypes.object,
    isKbbShown: PropTypes.bool,
    isGalleryOpen: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    onClose: PropTypes.func,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    updateAllFiltersVisibilityConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    allFilters: PropTypes.object,
    selectedFilters: PropTypes.object,
    selectedCity: PropTypes.string,
    setLoginTypeConnect: PropTypes.func,
    createOrderConnect: PropTypes.func,
    secureToken: PropTypes.func,
    createTestDriveAvailabilityConnect: PropTypes.func,
    tradeInToggleSelected: PropTypes.bool,
    isFetchingOrderDetails: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    personalDetails: PropTypes.object,
    updateProfileConnect: PropTypes.func,
    getOrderDetailConnect: PropTypes.func,
    orderId: PropTypes.string,
    calculatorRef: PropTypes.object,
    scrollToSection: PropTypes.func,
    updateValidC2bOrderConnect: PropTypes.func,
    webPriceDropDesktop: PropTypes.object,
    cityHubInfo: PropTypes.object,
    testDriveConfig: PropTypes.object,
    cmsConfig: PropTypes.object,
    updateWishlistNoteConnect: PropTypes.func,
    desktopCdpEw: PropTypes.object,
    paymentSummaryData: PropTypes.object,
    updateExtendedWarrantySelectionConnect: PropTypes.func,
    isVideoGalleryModalOpen: PropTypes.bool,
    isVideoGallery: PropTypes.bool,
    viewDetailsClick: PropTypes.func,
    isCdpCtaReorderVariant: PropTypes.bool,
    userTradeInData: PropTypes.object,
    globalCmsConfig: PropTypes.object,
    preApprovalOnFlyDesktop: PropTypes.object,
    startPreApprovalOnFlyConnect: PropTypes.func,
    comingSoonExperiment: PropTypes.object,
    getValidQuotesInHouseFinanceConnect: PropTypes.func,
    updateBasicHubspotConnect: PropTypes.func,
    getOrderDetailSuccessConnect: PropTypes.func,
    setTestDriveVariantConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    getInhousePreApprovalLoanDetailsConnect: PropTypes.func,
    userEmail: PropTypes.string
};

export default CarDetailsCardRevamp;
